import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../../assets/img/Logo.png';
import navLinks from './NavLinks';
import './Navbar.scss';

const Navbar = () => {
    const [closeIcon, setCloseIcon] = useState(false);
    
    return (
        <div className="Navbar">
            <nav className="navbar navbar-expand-lg navbar-dark nav-dark fixed-top">
                <div className="container">
                    <NavLink className="navbar-brand" to="/">
                        <img className="navbar-logo" height={ 35 } src={Logo} alt="Logo" />
                    </NavLink>
                    <button onClick={() => setCloseIcon( closeIcon => !closeIcon )} className="navbar-toggler shadow-none border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                       {closeIcon ? closeIcon && <i className="fas fa-times text-danger" /> : <i className="fas fa-bars text-danger" />}
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            {navLinks.map((navLink, index) => {
                                return(
                                    <li className="nav-item mx-2" key={index}>
                                        <NavLink className="nav-link" exact to={navLink.link}>
                                            {navLink.name}
                                        </NavLink>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
